import React, { useState, useImperativeHandle, useEffect, useRef } from 'react'
import { trans, plural } from '../../../../../_providers/Translation'

//images
import deleteIcon from "@/assets/img/reservations/icons/delete.svg"
import popupHeadImage from '@/assets/img/todo/icons/popup-head.svg'
import docIcon from '../../../../../assets/img/icons/document.png'
import closeIcon from '../../../../../assets/img/icons/close.png'
import Api from '../../../../../_helpers/Api'
import loader from '../../../../../assets/img/loader.svg'
import { useAuthDataContext } from '../../../../../_providers/Auth'
import Dropdown from '@/components/partials/Dropdown'
import { Checkbox, FormControlLabel } from '@mui/material'
import { useSnackbar } from 'notistack'

//TO DO
function AddOrEdit(props, ref) {
    const { enqueueSnackbar } = useSnackbar()
    const auth = useAuthDataContext()

    const inputFileRef = useRef(null)
    const formRef = useRef(null)

    const defaultData = {
        tags: [
            {
                employee: {}
            }
        ],
        repeat: false,
        repeat_after: 1
    }

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        edit: false,
        editId: null,
        alarm: [],
        data: defaultData,
        loading: false,
        employees: [],
    })

    const [priorities, setPriorities] = useState([])
    const [validations, setValidations] = useState(null)
    const [partners, setPartners] = useState([])

    useImperativeHandle(ref, () => ({
        add: () => {
            setPopup(prev => ({
                ...prev,
                edit: false,
                loading: false,
                data: defaultData
            }))

            handleShow()
        },
        edit: (id) => {
            setPopup(prev => ({
                ...prev,
                edit: Math.random().toString(),
                editId: id,
                data: defaultData,
                loading: false
            }))

            handleShow()
        },
        hide: () => {
            handleHide()
        }
    }))

    useEffect(() => {
        loadPriorities()
        loadPartners()

        if (auth.isAdmin()) {
            loadAdmins()
        } else {
            // loadEmployees()
        }
    }, [])

    // при редакция извлича текущите данни, за да се попълнят полетата
    useEffect(() => {
        if (popup.edit) {
            Api.get(`todos/find?id=${popup.editId}`)
                .then(res => {
                    // Extract employees and partners from tags
                    const employeeIds = Array.isArray(res.data.tags)
                        ? res.data.tags
                            .filter(tag => tag.user_id)
                            .map(tag => Number(tag.user_id))
                        : []

                    const partnerIds = Array.isArray(res.data.tags)
                        ? res.data.tags
                            .filter(tag => tag.partner_id)
                            .map(tag => Number(tag.partner_id))
                        : []

                    setPopup(prev => ({
                        ...prev,
                        data: {
                            ...res.data,
                            employees: employeeIds,
                            partners: partnerIds
                        },
                        alarm: res.data.alarms,
                    }))
                })
        }

    }, [popup.edit])

    const loadEmployees = () => {
        let url = 'partners/employees/all?active=1&sort=name'

        Api.get(url)
            .then(res => {
                setPopup(prev => ({
                    ...prev,
                    employees: res.data,
                    loading: false,
                    initLoad: false
                }))
            })
    }

    const loadAdmins = () => {
        let url = 'admins/all'

        Api.get(url)
            .then(res => {
                setPopup(prev => ({
                    ...prev,
                    employees: res.data,
                    loading: false,
                    initLoad: false
                }))
            })
    }


    const loadPriorities = () => {
        Api.get('todos/priorities')
            .then(res => {
                setPriorities(Array.isArray(res.data) ? res.data : (res.data?.data ?? []))
            })
    }

    const loadPartners = () => {
        let url = 'partners/relationships/all?page=1&group=sent'
        Api.get(url)
            .then(res => {
                // Assuming res.data.items contains the partners
                setPartners(res.data.items || [])
            })
    }

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        if (e) {
            e.preventDefault()
        }

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
            alarm: []
        }))

        setValidations(null)

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }))
        }, 50)
    }


    const handleSave = e => {

        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url

        if (popup.edit) {
            url = 'todos/edit'
        } else {
            url = 'todos/add'
        }

        let data = new FormData(e.target)

        //NEW: Добавяне на повтарящи се дни като масив
        if (Array.isArray(popup.data.repeat_days)) {
            popup.data.repeat_days.forEach(val => {
                data.append('repeat_days[]', val)
            })
        }

        // //NEW: Добавяне на изпълнители като масив 
        // if (Array.isArray((popup.data.employees || []))) {
        //     (popup.data.employees || []).forEach(val => {
        //         data.append('employees[]', val.id)
        //     })
        // }

        // //NEW: Добавяне на партньори като масив 
        // if (Array.isArray(popup.data.partners)) {
        //     popup.data.partners.forEach(val => {
        //         data.append('partners[]', val.related_partner_id)
        //     })
        // }

        // при редакция - добавяме ID
        if (popup.edit) {
            data.append('id', popup.editId)
        }

        if (popup.data.file) {
            data.append('file', popup.data.file)
        }

        Api.post(url, data)
            .then(res => {

                if (popup.edit) {
                    props.handleUpdate(res.data)
                } else {
                    props.handleCreate(res.data)
                }

                handleHide()

                formRef.current.reset()

                enqueueSnackbar(`Бележката е ${popup.edit ? "редактирана" : "създадена"} успешно!`, {
                    variant: "success",
                })

            }).catch(error => {

                enqueueSnackbar(`Грешка при ${popup.edit ? "редактиране" : "създаване"} на бележка!`, {
                    variant: "error",
                })

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    if (_err.data && _err.data.errors) {
                        for (let [input, err] of Object.entries(_err.data.errors)) {
                            setValidations(prevState => {
                                return { ...prevState, [input]: true }
                            })
                        }
                    }
                }

            })
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    const handleCheckboxChange = e => {
        let name = e.target.name

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: !prev.data[name]
            }
        }))
    }

    const handleEmployeeChange = e => {
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                tags: [
                    {
                        employee: {
                            ...prev.data.tags[0].employee,
                            id: val
                        }
                    }
                ]
            }
        }))

    }

    const handleDateChange = e => {
        let name = e.target.name + '_ymd'
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    const handleAdd = () => {

        let alarm = {
            id: Math.random().toString().substring(3),
        }

        setPopup(prev => ({
            ...prev,
            alarm: prev.alarm.concat(alarm)
        }))
    }

    const handleRemove = id => {
        let filtered = popup.alarm.filter(p => {
            return Number(p.id) !== Number(id)
        })

        setPopup(prev => ({
            ...prev,
            alarm: filtered
        }))
    }

    const handleAlarmChange = (e, i, field) => {
        const val = e.target.value

        let alarms = popup.alarm

        alarms[i][field] = val

        setPopup(prev => ({
            ...prev,
            alarm: alarms
        }))
    }

    const handleShowAttach = e => {
        e.preventDefault()

        inputFileRef.current.click()
    }

    const handleAttach = e => {
        let file = e.target.files[0]

        if (!file) {
            return
        }

        let url = URL.createObjectURL(file)

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                file: file,
                filename: file.name,
                file_url: url
            }
        }))

        inputFileRef.current.value = ''
    }

    const handleDetach = (e) => {
        if (popup.edit) {
            Api.post('todos/delete-file', {
                id: popup.editId
            }).then(res => {
                if (res.data.success) {
                    removeFile()
                }
            })
        } else {
            removeFile()
        }

    }

    const removeFile = () => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                file: null,
                filename: null,
            }
        }))
    }

    const getRepeatNumbers = () => {
        let n = []

        for (let i = 1; i <= 31; i++) {
            n.push(i)
        }

        return n
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form className={`${popup.modal ? 'show' : ''} popup-primary large`} autoComplete="off" onSubmit={handleSave} ref={formRef}>
                <div className='head-new'>
                    <img src={popupHeadImage} alt="popup head" />
                    <div className='texts'>
                        <h2>
                            {popup.edit ? trans('headings.editTodo') : trans('headings.addTodo')}
                        </h2>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit
                        </p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>

                <div className="row">

                    <div className="col">
                        <label htmlFor="heading">
                            {trans('labels.heading')}
                        </label>
                        <input
                            name="title"
                            type="text"
                            id="heading"
                            className={validations && validations.title ? 'validate' : ''}
                            value={popup.data && popup.data.title ? popup.data.title : ''}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div
                        className="col"
                        style={{
                            maxWidth: "205px"
                        }}
                    >
                        <label htmlFor="priority">
                            {trans('labels.priority')}
                        </label>
                        <select
                            name="priority_id"
                            value={popup.data && popup.data.priority_id ? popup.data.priority_id : ''}
                            id="priority"
                            className={validations && validations.priority_id ? 'validate' : ''}
                            onChange={handleInputChange}
                        >
                            {priorities.map(p =>
                                <option key={'p-' + p.id} value={p.id}>
                                    {p.translation.name}
                                </option>
                            )}
                        </select>
                    </div>

                </div>

                <div className='row'>
                    {auth.isSuperAdmin() || !auth.isAdmin()
                        ?
                        <div className='col'>

                            {/*
                            <select
                                multiple
                                name='employees[]'
                                value={Array.isArray((popup.data.employees || [])) ? (popup.data.employees || []).map(Number) : []}
                                onChange={e => {
                                    const selected = Array.from(e.target.selectedOptions, option => Number(option.value))
                                    setPopup(prev => ({
                                        ...prev,
                                        data: {
                                            ...prev.data,
                                            employees: selected
                                        }
                                    }))
                                }}
                            >
                                {popup.employees.map(emp => (
                                    <option
                                        key={emp.id}
                                        value={emp.id}
                                    >
                                        {emp.name} {emp.lastname}
                                    </option>
                                ))}
                            </select> */}
                            <label>
                                {trans('labels.contractor')}
                            </label>
                            <Dropdown
                                url="partners/employees/all?active=1&sort=name"
                                renderText={data => {
                                    return `${data.name} ${data.lastname}`
                                }}
                                onChange={data => {
                                    console.log(data)
                                    setPopup(prev => ({
                                        ...prev,
                                        data: {
                                            ...prev.data,
                                            employees: data
                                        }
                                    }))
                                }}
                                inputIdName='employees'
                                selectedIds={Array.isArray(popup.data.employees) ? popup.data.employees.map(emp => typeof emp === 'number' ? emp : emp.id) : []}
                                multiple
                                inputPlaceholder={trans('labels.contractor')}
                            />

                        </div>
                        :
                        ''
                    }

                    {/* //NEW: Добавяне на селектор за партньори, ако задачата е споделена и собствена т.е. може да се преотдава на партньори */}
                    {!(popup.data && popup.data.shared === 1 && popup.data.isOwner === false) && (
                        <div className='col'>

                            {/* <select
                                multiple
                                name='partners[]'
                                value={popup.data.partners || []}
                                onChange={e => {
                                    const selectedPartners = Array.from(e.target.selectedOptions, option => Number(option.value))
                                    setPopup(prev => ({
                                        ...prev,
                                        data: {
                                            ...prev.data,
                                            partners: selectedPartners
                                        }
                                    }))
                                }}
                            >
                                {partners.map(partner => (
                                    <option key={partner.id} value={partner.id}>
                                        {partner.name}
                                    </option>
                                ))}
                            </select> */}
                            <label>
                                {trans('labels.partners')}
                            </label>
                            <Dropdown
                                url="partners/relationships/registered"
                                renderText={data => {
                                    return <div>
                                        <p>{data.related_partner.name}</p>
                                        <p
                                            style={{
                                                color: "#A3AED0",
                                                fontSize: "11px"
                                            }}
                                        >{data.related_partner.email}</p>
                                    </div>
                                }}
                                onChange={data => {
                                    setPopup(prev => ({
                                        ...prev,
                                        data: {
                                            ...prev.data,
                                            partners: data
                                        }
                                    }))
                                }}
                                inputIdName='partners'
                                selectedIds={Array.isArray(popup.data.partners) ? popup.data.partners.map(emp => typeof emp === 'number' ? emp : emp.related_partner_id) : []}
                                multiple
                                inputPlaceholder={trans('labels.partners')}
                                inputIdField='related_partner_id'
                            />
                        </div>
                    )}
                    {/* //NEW: END/ */}
                </div>

                <div className="row">

                    <div
                        className="col"
                        style={{
                            maxWidth: "210px"
                        }}
                    >
                        <label htmlFor="date">
                            {trans('labels.setTo')}
                        </label>
                        <input
                            name="date"
                            type="datetime-local"
                            id="date"
                            className={validations && validations.date ? 'validate' : ''}
                            value={popup.data && popup.data.date_ymd ? popup.data.date_ymd : ''}
                            onChange={handleDateChange}
                        />
                    </div>

                    <div
                        className="col"
                        style={{
                            maxWidth: "210px"
                        }}
                    >
                        <label htmlFor="deadline">
                            {trans('labels.deadline')}
                        </label>
                        <input
                            name="deadline"
                            type="datetime-local"
                            id="deadline"
                            className={validations && validations.deadline ? 'validate' : ''}
                            value={popup.data && popup.data.deadline_ymd ? popup.data.deadline_ymd : ''}
                            onChange={handleDateChange}
                        />
                    </div>

                </div>
                <hr />
                {popup.data && !popup.data.parent_id
                    ?
                    <div
                        className="row"
                        style={{
                            alignItems: "center",
                            marginBottom: 0,
                        }}
                    >
                        <div
                            className="col"
                            style={{
                                paddingBottom: "20px"
                            }}
                        >
                            <div className='row'>
                                <div className='col'>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="repeat"
                                                size='small'
                                            />
                                        }
                                        value="1"
                                        checked={popup.data && popup.data.repeat ? true : false}
                                        onChange={handleCheckboxChange}
                                        label={trans('labels.repeat')}
                                    />
                                </div>
                            </div>
                            {popup.data && popup.data.repeat
                                ?
                                <div className='row'>
                                    <div className='col'>
                                        <div
                                            className="row"
                                            style={{
                                                flexShrink: 0,
                                                alignItems: 'center'
                                            }}
                                        >
                                            <label
                                                style={{
                                                    paddingBottom: 0,
                                                    paddingRight: "10px",
                                                    flexShrink: 0
                                                }}
                                            >
                                                {trans('labels.repeatOn')}
                                            </label>
                                            <select
                                                name="repeat_after"
                                                className={validations && validations.repeat_after ? 'validate' : ''}
                                                value={popup.data && popup.data.repeat_after ? popup.data.repeat_after : ''}
                                                onChange={handleInputChange}
                                                style={{
                                                    maxWidth: "140px"
                                                }}
                                            >
                                                {getRepeatNumbers().map((n, i) => (
                                                    <option key={'rn-' + i} value={n}>
                                                        {n}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='col'>
                                        <div
                                            className="row"
                                            style={{
                                                flexShrink: 0,
                                                alignItems: 'center'
                                            }}
                                        >
                                            <label
                                                style={{
                                                    paddingBottom: 0,
                                                    paddingRight: "10px",
                                                    flexShrink: 0
                                                }}
                                            >
                                                {trans('labels.period')}
                                            </label>
                                            <select
                                                name="repeat_period"
                                                className={validations && validations.repeat_period ? 'validate' : ''}
                                                value={popup.data && popup.data.repeat_period ? popup.data.repeat_period : ''}
                                                onChange={handleInputChange}
                                                style={{
                                                    maxWidth: "140px"
                                                }}
                                            >
                                                <option value={1}>
                                                    {plural('plural_periods.day', popup.data.repeat_after || 1)}
                                                </option>
                                                <option value={2}>
                                                    {plural('plural_periods.week', popup.data.repeat_after || 1)}
                                                </option>
                                                <option value={3}>
                                                    {plural('plural_periods.month', popup.data.repeat_after || 1)}
                                                </option>
                                                <option value={4}>
                                                    {plural('plural_periods.year', popup.data.repeat_after || 1)}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                :
                                ''
                            }
                        </div>


                        {popup.data && popup.data.repeat
                            ?
                            <div className='col'>
                                <label>
                                    {trans('labels.inDay')}
                                </label>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexWrap: "wrap",
                                        width: "260px",
                                        flexShrink: 0
                                    }}
                                >
                                    {[
                                        { value: 'monday', label: trans('dates.weekdaysMinObj.monday') },
                                        { value: 'tuesday', label: trans('dates.weekdaysMinObj.tuesday') },
                                        { value: 'wednesday', label: trans('dates.weekdaysMinObj.wednesday') },
                                        { value: 'thursday', label: trans('dates.weekdaysMinObj.thursday') },
                                        { value: 'friday', label: trans('dates.weekdaysMinObj.friday') },
                                        { value: 'saturday', label: trans('dates.weekdaysMinObj.saturday') },
                                        { value: 'sunday', label: trans('dates.weekdaysMinObj.sunday') },
                                    ].map(day => (
                                        <FormControlLabel
                                            key={day.value}
                                            control={
                                                <Checkbox
                                                    name="repeat_days"
                                                    size='small'
                                                />
                                            }
                                            value={day.value}
                                            checked={Array.isArray(popup.data.repeat_days) && popup.data.repeat_days.includes(day.value)}
                                            onChange={e => {
                                                const checked = e.target.checked
                                                let newDays = Array.isArray(popup.data.repeat_days) ? [...popup.data.repeat_days] : []
                                                if (checked) {
                                                    newDays.push(day.value)
                                                } else {
                                                    newDays = newDays.filter(d => d !== day.value)
                                                }
                                                setPopup(prev => ({
                                                    ...prev,
                                                    data: {
                                                        ...prev.data,
                                                        repeat_days: newDays
                                                    }
                                                }))
                                            }}
                                            label={day.label}
                                        />
                                    ))}
                                </div>
                            </div>
                            :
                            ''
                        }
                    </div>
                    :
                    ''
                }


                {popup.alarm.map((p, idx) => (
                    <React.Fragment key={'alarm-' + p.id}>
                        <div className='row'>
                            <div className="col">
                                <label>
                                    {trans('labels.notify')}
                                </label>
                                <div className='row'>
                                    <input type="hidden" name="period_id[]" value={p.id} />
                                    <input
                                        type="datetime-local"
                                        name="alarm[]"
                                        className={validations && validations[`alarm.${idx}`] ? 'validate' : ''}
                                        value={p.date_ymd}
                                        onChange={e => handleAlarmChange(e, idx, 'date_ymd')}
                                    />
                                </div>
                            </div>
                            <div className='col'>
                                <label>
                                    {trans('labels.notifyVia')}
                                </label>
                                <select
                                    value={p.type}
                                    name='type[]'
                                    onChange={e => handleAlarmChange(e, idx, 'type')}
                                >
                                    <option value='1'>{trans('random.systemNotification')}</option>
                                    <option value='2'>{trans('labels.email')}</option>
                                    <option value='3'>Viber/WhatsApp/SMS</option>
                                </select>
                            </div>
                            <div className="col" style={{
                                width: '40px',
                                minWidth: '40px',
                                paddingTop: '23px',
                                flexShrink: 0
                            }}>
                                <button
                                    className="button-remove"
                                    onClick={() => handleRemove(p.id)}
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        padding: 0,
                                        minWidth: "initial",
                                        flexShrink: 0,
                                    }}
                                >
                                    <img
                                        src={deleteIcon}
                                        alt="delete"
                                    />
                                </button>
                            </div>
                        </div>
                    </React.Fragment>
                ))}
                <div className="row">
                    <button className='button-small button-add' type="button" onClick={handleAdd}>
                        {trans('buttons.addNotification')}
                    </button>
                </div>

                <div className="row">
                    <div className="col">
                        <label htmlFor="text">
                            {trans('labels.content')}
                        </label>
                        <textarea
                            id="text"
                            name="text"
                            className={validations && validations.text ? 'validate' : ''}
                            value={popup.data && popup.data.text ? popup.data.text : ''}
                            onChange={handleInputChange}
                        >

                        </textarea>
                    </div>
                </div>

                {popup.data.file
                    &&
                    <div
                        className="row"
                        style={{
                            backgroundImage: 'linear-gradient(to right, #f1f1f1, #ffffff)',
                            padding: "5px",
                            borderRadius: "4px"
                        }}
                    >
                        <div
                            className="col"
                            style={{
                                justifyContent: "center"
                            }}
                        >
                            <a
                                href={popup.data.file_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className='link'
                                style={{
                                    fontSize: "14px",
                                    textDecoration: "underline"
                                }}
                            >
                                {popup.data.filename || 'n/a'}
                            </a>
                        </div>
                        <div className="col" style={{
                            width: '40px',
                            minWidth: '40px',
                            flexShrink: 0
                        }}>
                            <button
                                className="button-remove"
                                onClick={handleDetach}
                                style={{
                                    width: "40px",
                                    height: "40px",
                                    padding: 0,
                                    minWidth: "initial",
                                    flexShrink: 0,
                                }}
                            >
                                <img
                                    src={deleteIcon}
                                    alt="delete"
                                />
                            </button>
                        </div>
                    </div>
                }

                <div className="row">
                    <button className='button-small' type="button" onClick={handleShowAttach}>
                        {trans('buttons.uploadfile')}
                    </button>
                </div>

                <input ref={inputFileRef} type="file" onChange={handleAttach} hidden />

                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form >
        </div >
    )
}

export default React.forwardRef(AddOrEdit)